<template>
  <div>
    <div class="container">
      <div class="row justify-content-center">
        <div class="card pb-5 my-5" style="width:100%">
          <div class="card-body">
            <div class="text-center mb-4">
              <img src="../assets/img/hokodo_logo_color.svg" alt="Hokodo" width="200" height="38.5">
            </div>
            <div v-if="reset_complete" class="text-center mb-4">
              <icon name="check-circle" class="feather-large"></icon>
              <h3 class="my-4">Password reset requested</h3>
              <p class="pb-4">A password reset email was sent to your email address.<br>Please click on the link in the email to reset your password.</p>
            </div>
            <form class="form-signin" v-on:submit.prevent="reset" v-else>
              <p class="my-3 text-muted text-center">We'll send you a link to reset your password.</p>

              <div class="form-group">
                <input type="email" id="inputEmail" class="form-control" placeholder="Your Email" v-model="email" v-bind:class="{ 'is-invalid': (error && error.email) }" @keyup.enter="reset" required autofocus>
                <div class="mb-3 invalid-feedback" v-if="error && error.email">
                  <p v-for="(description,index) in error.email" :key="index">{{description}}</p>
                </div>
              </div>

              <button class="btn btn-lg btn-primary btn-block" type="button" v-on:click="reset" :disabled="loading"><icon name="settings" class="feather-spin" v-if="loading"></icon> Send reset password email</button>
            </form>
          </div>
        </div>
      </div>
    </div>
    <hokodo-footer></hokodo-footer>
  </div>
</template>

<script>
import HokodoFooter from './partials/HokodoFooter'

export default {
  data () {
    return {
      loading: false,
      email: null,
      error: null,
      reset_complete: false
    }
  },
  components: {
    HokodoFooter
  },
  methods: {
    reset: function () {
      this.loading = true
      this.$store.dispatch('auth/resetPassword', {email: this.email}).then(() => {
        this.reset_complete = true
      }, (error) => {
        // Login failed
        this.loading = false
        this.error = error
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Reset.vue